import createIcon from '../../createIcon';

/**
 * @component @name ExposurePlus1
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTAgNy41SDhWMTEuNUg0VjEzLjVIOFYxNy41SDEwVjEzLjVIMTRWMTEuNUgxMFY3LjVaTTIwIDE4LjVIMThWNy44OEwxNSA4LjlWNy4yTDE5LjcgNS41SDIwVjE4LjVaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const ExposurePlus1 = createIcon('ExposurePlus1', [
  [
    'path',
    {
      d: 'M10 7.5H8V11.5H4V13.5H8V17.5H10V13.5H14V11.5H10V7.5ZM20 18.5H18V7.88L15 8.9V7.2L19.7 5.5H20V18.5Z',
      key: '1k5l01',
    },
  ],
]);

export default ExposurePlus1;
